const SUPPORTED_CHAIN_IDS = [1, 5, 10, 56, 137, 31337]

export default SUPPORTED_CHAIN_IDS